import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  rezervasyonGetir,
  rezervasyonIptal,
  rezervasyonlariListele,
  type RezervasyonSorgusu,
  type SayfalanmisRezervasyonlar,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useRezervasyonListesi(sorgu: Partial<RezervasyonSorgusu>) {
  return useQuery<SayfalanmisRezervasyonlar>({
    queryKey: ['rezervasyonlar', 'liste', sorgu],
    queryFn: () => rezervasyonlariListele(istemci, sorgu),
    placeholderData: (onceki) => onceki,
  });
}

export function useRezervasyon(id: string | undefined | null) {
  return useQuery({
    queryKey: ['rezervasyonlar', 'detay', id ?? ''],
    queryFn: () => rezervasyonGetir(istemci, id as string),
    enabled: !!id,
  });
}

export function useRezervasyonIptal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => rezervasyonIptal(istemci, id),
    onSuccess: (_, id) => {
      qc.invalidateQueries({ queryKey: ['rezervasyonlar', 'liste'] });
      qc.invalidateQueries({ queryKey: ['rezervasyonlar', 'detay', id] });
      qc.invalidateQueries({ queryKey: ['dolaplar'] });
    },
  });
}
